import { Fiat, FiatWallet } from "@models";
import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { ContactService } from "@main-services/contact.service";
import { FiatService } from "@main-services/currency/fiat.service";
import { AccountService } from "@modules/account/services/account.service";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { CurrencyTransactionListItemComponent } from "../../currency-transaction-list-item.component";
import { empty } from "@helpers/utils";
import { TradableTransaction } from "@models/transaction";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { EMPTY, Observable } from "rxjs";
import { WalletBalance } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.model";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";

@Component({
	selector: "tradable-transaction-list-item",
	templateUrl: "./tradable-transaction-list-item.component.html",
	styleUrls: ["./tradable-transaction-list-item.component.scss"],
	standalone: false
})
export class TradableTransactionListItemComponent
	extends CurrencyTransactionListItemComponent
	implements OnInit, AfterViewInit
{
	@Input() public focusable: boolean = false;

	@Input() public transaction: TradableTransaction = null;

	@Input() public isInnerIndexTransaction: boolean = false;

	@Input() public isWidget: boolean = false;

	public balance: Observable<WalletBalance> = EMPTY;

	public constructor(
		protected masterdataService: MasterdataService,
		protected tradableWalletListService: TradableWalletListService,
		protected fiatService: FiatService,
		protected contactService: ContactService,
		protected accountService: AccountService,
		protected tradableListService: TradableListService,
		protected fiatwalletService: FiatWalletService,
		protected modalService: ModalService,
		protected walletBalanceFacade: WalletsBalancesFacadeService
	) {
		super(masterdataService, tradableWalletListService, fiatService, tradableListService, modalService);
	}

	public ngOnInit(): void {
		this.balance = this.walletBalanceFacade.getCryptoWalletBalance$(this.transaction.getWalletId());
	}

	public ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	protected initPidValue(): void {
		const prefix = this.transaction.hasTrade() ? "T" : "C";
		const id = this.transaction.hasTrade() ? this.transaction.getTrade().getId() : this.transaction.getId();
		this.pid = prefix + id;
	}

	public get fiat(): Fiat {
		return this.accountService.getDefaultFiat() || new Fiat();
	}

	public get fiatwallet(): FiatWallet {
		return this.fiatwalletService.getItemById(this.transaction.getTrade().getFiatWalletId());
	}

	public getRecipient(): string {
		if (!this.transaction) {
			return "";
		}
		if (this.transaction.hasRecipient()) {
			return this.transaction.getRecipient();
		}

		const contact = this.contactService.getItemById(this.transaction.getContactId());

		if (empty(contact)) {
			return "";
		}
		if (!contact.isDeleted()) {
			return contact.getName();
		}

		if (contact.getEmail().length > 0) {
			return contact.getEmail();
		}

		const emailField = contact
			.getFields(true, true)
			.filter((f) => f.getType() === "email" && f.getValue().length > 0);
		if (emailField.length > 0) {
			return emailField[0].getValue();
		}

		return "transactions_bitpanda_user";
	}

	public get amount(): number {
		if (this.transaction.getCurrentFiatId() === this.fiat.getId()) {
			return +this.transaction.getCurrentFiatAmount();
		}

		if (!this.fiat) {
			return 0;
		}
		return +this.transaction.getAmountEuro() / this.fiat.toEuroRate();
	}
}
